import * as ROUTE from 'constants/routes';

export const PATIENTS_INCOMPLETE_INFO_ROUTE = `${ROUTE.PATIENTS.VALUE}${ROUTE.PATIENTS.SUB_ROUTE.INCOMPLETE.VALUE}`;

export const MAX_ENTRIES_PER_PAGE = 10;
